module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“F")])]), _vm._v("lowers?” Police Chief Jake Sutton spotted the enormous bouquet of roses the moment he stepped into the break room, where the officers roosted near the coffee pot before heading out on patrol every morning. “I’m touched, guys, but you shouldn’t have.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The three men staring morosely at the fragrant centerpiece snapped to attention at the sound of his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We didn’t,” Phil Koenigs muttered, the droop of his narrow shoulders more pronounced than usual.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No offense, though, Chief,” Tony Tripenski added quickly. “We would have brought you flowers if we knew you liked them.” His eyes widened when he saw Jake’s eyebrow lift. “I mean, not that you look like the type of guy who likes flowers…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Phil rolled up the fingers on one hand and cuffed Tony on the shoulder. “Put the shovel away, Trip. All you’re doing is digging yourself a deeper hole.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Glowering, the younger officer folded his arms across his chest and slumped lower in the chair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake paused long enough to pour himself a cup of coffee before making his way to the table. Something warned him that he was going to need the extra caffeine. "), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("The last time he’d seen the men in such a dismal mood was the day he’d officially been sworn in as Mirror Lake’s new police chief.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He flipped an empty chair away from the table and straddled it. “If one of you has a secret admirer, you’d look a little happier. That means someone must be in the doghouse with the wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The doghouse would be easier,” Steve Patterson, one of the part-time officers, grumbled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah.” Trip nodded. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Much")]), _vm._v(" easier. I’d rather face Sherry when she’s in a mood than…” His voice dropped to a whisper. “You know who.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No, Jake didn’t know. He hadn’t been born and raised in the area, something more than a few people had been quick to point out since his arrival.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His gaze cut back to Phil. If he wanted a straight answer, it would most likely come from the senior officer. As second in command, Phil had been the most likely candidate to step into the shoes of the former police chief, who’d opted for an early retirement. Instead, he’d astonished everyone by turning down the position.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Any concern that Phil’s decision would make the transfer of power a rocky one had been put to rest when Jake found out Phil was the one who’d pulled his resume from the stack of applications and given it his personal stamp of approval.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("He still wasn’t quite sure why. But he did know that if it weren’t for the dour officer’s willingness to fill him in on the local—and sometimes colorful—history of the town and the people who lived there, Jake might still be suffering from an acute case of culture shock. Within the first twenty-four hours, he’d discovered that ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("what Mirror Lake lacked in population, it made up for in quirks.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had a feeling he was about to add another one to the list.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He glanced at the officer, surprised when Phil averted his gaze. “Phil? Flowers?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The officer scratched at a coffee stain on the table with his thumbnail. Sighed. “They’re for Emma Barlow.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay.” Jake drew a blank on the name. “I’ll bite. Who is Emma Barlow?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The three men exchanged looks but none of them seemed in a hurry to enlighten him. Jake waited, drawing on the patience that had become second nature while working as an undercover narcotics officer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Brian Barlow’s widow,” Phil finally said. “Brian was a good man. A good…cop.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Was.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake didn’t miss the significance of the word. Or the flash of grief in the older officer’s eyes. It was the first time he’d heard about the department losing an officer. Apparently that was one bit of local history Phil hadn’t been eager to share. “What happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He was killed in the line of duty six years ago. High-speed chase.” Steve picked up the story with a sideways glance at Phil, who’d lapsed into silence again. “On the anniversary of his death, one of us takes flowers to his wife…” He caught himself. “I mean his widow.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s thoughtful of you.” Jake wasn’t surprised. From what he’d learned about the town over the past few weeks, an annual tribute to a fallen officer was the kind of thing he’d expect from the tightly knit group of people who lived in Mirror Lake.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No one agreed or disagreed with the statement. But if anything, they looked more miserable than they had when he’d walked in. For the first time, Jake noticed three plastic straws lined up next to the vase.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Absently, he picked one up and rolled it between his fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("short")]), _vm._v(" one.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His eyes narrowed but no one noticed. Probably because they’d all found a different focal point in the room to latch on to.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The evidence in front of him and the officers’ expressions could only lead Jake to one conclusion.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t tell me that you’re drawing straws to see who gets to deliver the flowers?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No.” Trip almost choked on the word.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake might have believed the swift denial if the tips of Trip’s ears hadn’t turned the same shade of red as his hair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned to Steve and raised an eyebrow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Steve’s Adam’s apple convulsed in response. “We draw straws to decide who "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("has")]), _vm._v(" to deliver them,” he muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let me get this straight. You buy Emma Barlow flowers every year but no one wants to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("give")]), _vm._v(" them to her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Absolute silence followed the question. Which, Jake decided, was an answer in itself. Under any circumstances, it was difficult to lose a fellow officer, but in a small community like Mirror Lake, he guessed it had shaken the town to its very foundation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He buried a sigh. “I’ll drop them off. Where does she live?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("The officers stared at Jake as if he’d just volunteered ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("to walk into a drug deal wearing a wire on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("outside")]), _vm._v(" of his clothes.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“You?”")]), _vm._v(" Steve’s voice cracked on the word.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not quite the reaction Jake had expected.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is there something I’m missing here?” he asked. “Don’t I just knock on the door, express my condolences and give Emma Barlow the flowers?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Phil opened his mouth to speak but Trip and Steve beat him to it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s pretty much it, Chief.” A hopeful look dawned in Trip’s eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yup.” Steve’s head bobbed in agreement. “That’s all there is to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Phil?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The officer’s fingers drummed an uneven beat against the table. “That’s usually the way it goes,” he said cautiously. Usually?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So you think she would be more comfortable if someone she knew brought them over—” Jake didn’t have a chance to finish the sentence. Phil’s radio crackled to life as a call came in from dispatch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The three officers surged to their feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Better go.” Phil moved toward the door at an impressive speed, Steve and Trip practically stumbling over his heels in their haste to follow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wait a second.” Jake couldn’t believe what he was seeing. “It takes all three of you to respond to a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dog")]), _vm._v(" complaint?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Phil had already disappeared, leaving Steve and Trip glued to the floor as if Jake had aimed a spotlight on them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It might be a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("big")]), _vm._v(" dog,” Trip mumbled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Huge.” Steve nodded.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And vicious,” Trip added. “You never know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s true.” Jake suppressed a smile. “So, in the interest of maintaining public safety, I’ll expect a full, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("written")]), _vm._v(" report on this large, vicious dog and details of the encounter before you leave today.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The officers’ unhappy looks collided in midair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure, Chief.” Trip plucked at his collar. “Not a problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He vanished through the doorway but Steve paused for a moment. “Emma Barlow lives in the last house on Stony Ridge Road. It’s a dead end off the west side of the lake—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A hand closed around Steve’s arm and yanked him out of sight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Definitely one for the list.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Emma Barlow sat at the kitchen table, palms curled around a cup of tea that had cooled off more than an hour ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ordinarily, she could set her clock by the arrival of an officer from the Mirror Lake Police Department. Nine o’clock sharp, as if the stop at her house was the first order of business for the day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Or something to get over with as quickly as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sometimes Emma wondered if the officers dreaded August fifteenth as much as she did.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After six years, she knew exactly what to do. As if every moment, every movement, were choreographed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Emma would open the door and find one of the officers, most likely Phil Koenigs, standing on the porch with a bouquet of red roses. Always roses.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They didn’t speak. Emma preferred it that way. She accepted the flowers more easily than she would have awkward condolences. Or even worse, a pious reminder that God loved her and she should accept Brian’s death as His will.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Emma had often wondered why no one else saw the contradiction there. If God really loved her, would He have left her a widow at the age of twenty-four? Wouldn’t He have somehow intervened to save Brian?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Those were the kinds of questions that ran through Emma’s mind during the sleepless nights following the funeral, but she’d learned not to voice them out loud. It hadn’t taken her long to discover that most people, no matter how sympathetic or well-meaning, seemed to give grief a wide berth. As if they were afraid if they got too close, it would touch—or stain—their own lives somehow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No one liked to be reminded how fragile life could be. Especially another police officer, who looked at her and saw Brian instead. A life cut short.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe that explained why the officers remained poised on the top step, waiting for her to take the flowers. She would then nod politely. Step back into the house. Close the door. Listen for the car to drive away. The roses would be transported to the cemetery and carefully arranged, one by one, in the bronze vase on Brian’s grave.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What she really wanted to do was throw them away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If it weren’t for Jeremy, she probably would. Although her ten-year-old son had very few memories of his father, he took both pride and comfort in knowing that an entire community did.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jeremy had lost enough; Emma wasn’t about to take that away from him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unlike her, Brian had been born and raised in Mirror Lake. He’d left after graduation, only to return two years later with a degree in Police Science and a gold wedding band on his left hand, a perfect match with the one now tucked away in her jewelry box.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The snap of a car door closing sucked the air from Emma’s lungs. Lost in thought, she hadn’t heard a car pull up the driveway. Through the panel of lace curtains on the window, Emma caught a glimpse of a light bar on top of the vehicle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rising to her feet, she tried to subdue the memories that pushed their way to the surface. Memories of the night she’d fallen asleep on the sofa, waiting for Brian to come home. But instead of her husband, a visibly shaken Phil Koenigs had shown up at the door…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You can do this, Em. Open the door. Take the roses. Nod politely. Close the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her fingers closed around the knob. And her heart stumbled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It wasn’t Phil who stood there, a bouquet of long-stemmed roses pinched in the bend of his arm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was a stranger, empty-handed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Emma Barlow?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A stranger who knew her name.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Emma managed a jerky nod. “Y-yes.” Her voice sounded as rusty as the screen door she hadn’t found time to replace.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m Jake Sutton.” He extended his hand. “The new police chief.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Before she knew what was happening, Emma felt the warm press of his fingers as they folded around hers.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("She’d heard a rumor about Chief Jansen’s upcoming ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("retirement but hadn’t realized he’d been replaced yet. Replaced by a man in his midthirties, whose chiseled features and tousled dark hair gave him an edgy look. A faint web of scars etched the blade of his jaw, as pale and delicate as frost on a window. If it weren’t for the white dress shirt and badge, he would have looked more like someone who walked the edge of the law, not a man who dedicated his life enforcing it.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Emma pulled her hand away, no longer sure what she should say. Or do.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake Sutton had just changed the rules.")])])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page15"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49b9f43e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426866456_ch01.vue
// module id = 78
// module chunks = 0